import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DeliveryZoneState } from '../reducers';

export const selectDeliveryZoneState = createFeatureSelector<DeliveryZoneState>('deliveryZone');

export const selectDeliveryZoneLoading = createSelector(
  selectDeliveryZoneState,
  (state: DeliveryZoneState) => state.loading
);

export const selectDeliveryZoneEditMode = createSelector(
  selectDeliveryZoneState,
  (state: DeliveryZoneState) => state.editMode
);

export const selectDeliveryZoneIsEditing = createSelector(
  selectDeliveryZoneState,
  (state: DeliveryZoneState) => state.isEditing
);

export const selectDeliveryZone = createSelector(
  selectDeliveryZoneState,
  (state: DeliveryZoneState) => state.deliveryZone
);

export const selectDeliveryZoneList = createSelector(
  selectDeliveryZoneState,
  (state: DeliveryZoneState) => state.deliveryZoneList
);

export const selectDeliveryZoneForm = createSelector(
  selectDeliveryZoneState,
  (state: DeliveryZoneState) => state.deliveryZoneForm
);

export const selectDeliveryZoneError = createSelector(
  selectDeliveryZoneState,
  (state: DeliveryZoneState) => state.error
);

export const selectDeliveryZoneAvailable = createSelector(
  selectDeliveryZoneState,
  (state: DeliveryZoneState) => state.deliveryZoneAvailable
);
